var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{style:({width: this.size/2 + 'px'}),attrs:{"src":_vm.handleSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }